import { useMemo } from "react";
import * as Yup from "yup";

export default function useValidations() {
  return useMemo(
    () =>
      Yup.object().shape({
        username: Yup.string().required("No puede estar vacio")
        .min(3, "No puede tener menos de 3 caracteres").max(60, "Maximo de 60 caracteres"),
        password: Yup.string()
          .required("No puede estar vacio")
          .min(8, "No puede tener menos de 8 caracteres"),
        confirmPassword: Yup.string()
          .required("No puede estar vacio")
          .min(8, "No puede tener menos de 8 caracteres")
          .oneOf([Yup.ref("password"), null], "Las contrasenas no coinciden"),
        role: Yup.string().required("Debe seleccionar uno"),
        fullName: Yup.string().required("No puede estar vacio")
          .min(4, "No puede tener menos de 4 caracteres")
          .max(120, "No puede tener mas de 120 caracteres"),
        email: Yup.string()
          .required("No puede estar vacio")
          .email("Correo Invalido"),
        telephone: Yup.number()
          .integer("No puede tener decimales")
          .test(
            "test-name",
            "Ingrese un número de teléfono válido de 8 dígitos.",
            (value) => {
              return (
                !value ||
                (value &&
                  Number.isInteger(value) &&
                  value.toString().length >= 8 &&
                  value.toString().length <= 8)
              );
            }
          )
          .typeError(
            "No debe incluir caracteres especiales, como #@&%-/, ni caracteres alfabéticos."
          ),
      }),
    []
  );
}
